import { render, staticRenderFns } from "./editFactory.vue?vue&type=template&id=541669b3&scoped=true&"
import script from "./editFactory.vue?vue&type=script&lang=js&"
export * from "./editFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541669b3",
  null
  
)

export default component.exports